import { JOURNAL, JSTOR } from '@chegg-wt/core/constants/journalTypes'
import { JournalType } from '@chegg-wt/core/types/core'
import React from 'react'

import * as Styled from './styled'

export const TESTID_JOURNAL_TABS = 'journal-tabs'
export const TESTID_SEARCH_RESULTS_TAB = 'search-results-tab'
export const TESTID_JSTOR_TAB = 'jstor-tab'

export const JOURNAL_TAB_COPY = 'Search results'
export const JSTOR_TAB_COPY = 'JSTOR'

interface Props {
  active: JournalType
  onChange: (type: JournalType) => void
}

const JournalTabs: React.FC<Props> = ({ onChange, active }) => {
  return (
    <Styled.JournalTabs data-test={TESTID_JOURNAL_TABS}>
      <Styled.JournalTab
        onClick={() => onChange(JOURNAL)}
        active={active === JOURNAL}
        data-test={TESTID_SEARCH_RESULTS_TAB}
      >
        Search results
      </Styled.JournalTab>
      <Styled.JournalTab
        onClick={() => onChange(JSTOR)}
        active={active === JSTOR}
        data-test={TESTID_JSTOR_TAB}
      >
        JSTOR
      </Styled.JournalTab>
    </Styled.JournalTabs>
  )
}

export default JournalTabs
